import React, { useEffect, useState, useContext } from 'react'
import PracticePatientService from '../../../../../../services/api/patient-type.service'
import Table2 from '../../../../../templates/components/Table2'
import { store } from '../../../../../../context/StateProvider'
import ModalBox from '../../../../../templates/components/ModalBox'
import AddPatientType from '../../../patient-type/add-patienttype/AddPatientType'
import EditPatientType from '../../../patient-type/edit-patienttype/EditPatientType'
import toast from 'react-hot-toast'
import APIResponse from '../../../../../templates/components/APIResponse'
import DimLoader from '../../../../../templates/components/DimLoader'

const PracticePatientTypeTable = (props) => {
    const globalStateAndDispatch = useContext(store)
    const contextState = globalStateAndDispatch.state
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [isLoader_Practicepatient, setIsLoader_Practicepatient] = useState(false)
    const [patientTypeList, setPatientTypeList] = useState()
    const [selectedPatientType, setSelectedPatientType] = useState()
    const [deleteModal, setDeleteModal] = useState()
    const [apiResponse, setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const onSuccess = (message) => {
        setPatientTypeList([]); 
        practicePatientTypeLookup()
    }
    const practicePatientTypeLookup = () => {
        setIsLoader_Practicepatient(true);
        PracticePatientService.practicePatientTypeLookup()
            .then((response) => {
                if (response?.data?.data?.selectResponse.length > 0) {
                    setPatientTypeList(response.data.data.selectResponse);
                } else {
                    setPatientTypeList([]);
                }
                setIsLoader_Practicepatient(false);
            })
            .catch(error => {
                setIsLoader_Practicepatient(false);
                setPatientTypeList([]);
            })
    }

    const deleteItem = () => {
        setIsLoader(true)
        return PracticePatientService.deletePatientType(selectedPatientType.practicePatientTypeId)
            .then(res => {
                setApiResponse(res);
            })
            .catch(err => {
                setApiResponse(err);
            }).finally(() => {
                setIsLoader(false)
            });
    }


    useEffect(() => {
        practicePatientTypeLookup()
    }, [])

    const patientTypeColumns = [
        {
            id: "patientType",
            Header: "Patient Type",
            accessor: type => type.patientType
        },
        {
            id: "appointmentBorderColor",
            Header: "Appointment Border Color",
            disableSortBy: true,
            accessor: (practicePatient, i) => {
                return (
                    <div className="d-flex justify-content-center appointment-style">
                        <span className="me-3" style={{ height: '15px', width: '15px', display: 'block', backgroundColor: practicePatient.appointmentBorderColor }} title={practicePatient.appointmentBorderColor}></span> <p>{practicePatient.appointmentBorderColor}</p>
                    </div>
                )
            },
            getCellExportValue: (tc) => {
                return tc.original.appointmentBorderColor ? tc.original.appointmentBorderColor : "";
            }
        },
        {
            id: "isDefault",
            Header: "Default",
            accessor: type => type.isDefault ? "Yes" : ""
        },
        {
            id: "actionPracticePatient",
            Header: "Action",
            disableSortBy: true,
            excludeFromExport: true, //to exclude from export
            textAlign: 'center',
            accessor: (practicePatient, i) => {
                return (
                    <div className='d-flex justify-content-center'>
                        <button className="p-0 ps-1 btn btn-primary" title="edit" onClick={e => { e.preventDefault(); setSelectedPatientType(practicePatient); return setShowEdit(true) }}><i className="icon pencil" /></button>
                        <button className="p-0 ps-1 btn btn-primary ms-1" title="delete" onClick={e => { e.preventDefault(); setSelectedPatientType(practicePatient); return setDeleteModal(true) }}><i className="icon trash" /></button>
                    </div>
                )
            }
        }
    ]

    return (
        <>{isLoader ? <DimLoader loadMessage="Processing.." /> : null}
            <div title='Practice Patient Type'>
                <Table2
                    data={patientTypeList}
                    columns={patientTypeColumns}
                    loading={isLoader_Practicepatient}
                    export searchable
                    extraButtons={[{
                        className: 'btn btn-primary',
                        title: "Add Practice Patient",
                        children:
                            <span><i className='icon plus' /></span>
                        ,
                        onClick: () => {
                            setShowAdd(true);
                        }
                    }]} />
            </div>
            <ModalBox open={showEdit} onClose={() => { setSelectedPatientType(); setShowEdit(false) }} title="Edit Patient Type" size="small">
                <EditPatientType
                    initialData={selectedPatientType}
                    refresh={() => { setPatientTypeList([]);  practicePatientTypeLookup()}}
                    onClose={() => { setSelectedPatientType(); setShowEdit(false) }}
                    isModal
                />
            </ModalBox>
            <ModalBox open={showAdd} onClose={() => { setShowAdd(false) }} title="Add Patient Type" size="small">
                <AddPatientType
                    refresh={() => { setPatientTypeList([]); practicePatientTypeLookup()}}
                    onClose={() => { setShowAdd(false) }}
                    isModal
                />
            </ModalBox>
            <ModalBox open={deleteModal} onClose={() => { setDeleteModal(false) }} title="Delete Patient Type" size="tiny">
                {selectedPatientType?.practicePatientTypeId && <><span>Are you sure you want to delete {selectedPatientType.patientType}?</span>
                    <div className='d-flex justify-content-between mt-3'>
                        <div className='col-auto'><button className='btn btn-primary' onClick={e => { e.preventDefault(); deleteItem(); setDeleteModal(false) }}>Yes</button></div>
                        <div className='col-auto'><button className="btn btn-secondary" onClick={e => { e.preventDefault(); setSelectedPatientType(); setDeleteModal(false) }}>No</button></div>
                    </div>
                </>}
            </ModalBox>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default PracticePatientTypeTable